import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
    selector: 'lui-dialog-actions',
    template: ` <ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DialogActionsComponent {
  @Input() align: 'start' | 'center' | 'end' | 'between' = 'start';

  @HostBinding('class') hostClasses = ['lui-dialog-actions', 'zone-dark'];

  @HostBinding('class.lui-dialog-actions-start') get startClass() {
    return this.align === 'start';
  }

  @HostBinding('class.lui-dialog-actions-center') get centerClass() {
    return this.align === 'center';
  }

  @HostBinding('class.lui-dialog-actions-end') get endClass() {
    return this.align === 'end';
  }

  @HostBinding('class.lui-dialog-actions-between') get betweenClass() {
    return this.align === 'between';
  }
}
